module.exports = __webpack_public_path__ + "static/media/times-regular.1e5bee47.svg";